import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCnqFuu9uCdAZFwRdDvZjdOFWsjym0vbUU",
  authDomain: "venue-manager-2677b.firebaseapp.com",
  projectId: "venue-manager-2677b",
  storageBucket: "venue-manager-2677b.firebasestorage.app",
  messagingSenderId: "730904243699",
  appId: "1:730904243699:web:d3bddbeee6a1a61d363686",
  measurementId: "G-6L7DSDS92M",
};

/** Web Push certificate key (Firebase Console → Cloud Messaging). Override via env. */
const VAPID_KEY =
  process.env.REACT_APP_VAPID_KEY ||
  process.env.REACT_APP_FIREBASE_VAPID_KEY ||
  "BAxGujcW86glCwkem40pBM67nn7Aqexg87yt0YDSwHK_hAOpAlvgqVE7qysJFiBrDGbTDsDWaRTJtMfLqzw5zSE";

const SESSION_FCM_WEB_TOKEN_KEY = "fcm_web_token";

const firebaseApp = initializeApp(firebaseConfig);

let messaging = null;

const ensureMessaging = async () => {
  if (typeof window === "undefined") return null;
  if (messaging) return messaging;
  const supported = await isSupported().catch(() => false);
  if (!supported) return null;
  messaging = getMessaging(firebaseApp);
  return messaging;
};

/** @deprecated Prefer ensureMessaging via ensureWebFcmToken / onForegroundMessage. */
export const getMessagingInstance = () => messaging;

export const getOrRegisterServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) {
    throw new Error("The browser doesn't support service workers.");
  }
  let registration = await navigator.serviceWorker.getRegistration("/");
  if (!registration) {
    registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
  }
  return navigator.serviceWorker.ready;
};

/**
 * Request notification permission (if needed) and return the current FCM token.
 * Pass this on login with platform: "web".
 */
export const ensureWebFcmToken = async ({ requestPermission = true } = {}) => {
  try {
    if (!("Notification" in window)) return null;

    let permission = Notification.permission;
    if (permission === "default" && requestPermission) {
      permission = await Notification.requestPermission();
    }
    if (permission !== "granted") return null;

    const messagingInstance = await ensureMessaging();
    if (!messagingInstance) return null;

    const serviceWorkerRegistration = await getOrRegisterServiceWorker();
    const token = await getToken(messagingInstance, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration,
    });

    if (token) {
      try {
        sessionStorage.setItem(SESSION_FCM_WEB_TOKEN_KEY, token);
      } catch (_) {
        /* ignore */
      }
    }
    return token || null;
  } catch (err) {
    console.error("Firebase token error:", err);
    return null;
  }
};

export const getFirebaseToken = () =>
  ensureWebFcmToken({ requestPermission: false });

export const requestFirebaseNotificationPermission = () =>
  ensureWebFcmToken({ requestPermission: true });

export const getStoredFcmWebToken = () => {
  try {
    return sessionStorage.getItem(SESSION_FCM_WEB_TOKEN_KEY) || "";
  } catch (_) {
    return "";
  }
};

export const onForegroundMessage = async (callback) => {
  const messagingInstance = await ensureMessaging();
  if (!messagingInstance) return () => {};
  return onMessage(messagingInstance, callback);
};

export const onMessageListener = () =>
  new Promise(async (resolve) => {
    const messagingInstance = await ensureMessaging();
    if (!messagingInstance) {
      resolve(null);
      return;
    }
    onMessage(messagingInstance, (payload) => resolve(payload));
  });
